export default {
  methods: {
    getShopPower(columns) {
      let user = this.$utils.getSysUser();
      let storeId = columns.filter((item) => item.prop === "storeId")[0];
      if (!user.storeId) {
        storeId.param = {merchantId: user.storeId};
      } else{
        storeId.defaultValue = user.storeId;
        storeId.disabled = true;
      }
    },
    // 默认门店隐藏
    setStore(params) {
      let user = this.$utils.getSysUser();
      let storeId = params.filter((item) => item.prop === "storeId" || item.prop === 'storeIds')[0];
      if (!user.storeId) {
        storeId.disabled = false;
        storeId.hidden = false;
      } else{
        storeId.disabled = true;
        storeId.defaultValue = user.storeId;
        storeId.hidden = true;
      }
    },
    setStoreInfo(params) {
      let user = this.$utils.getSysUser();
      let storeId = params.filter((item) => item.prop === "storeId" || item.prop === 'storeIds')[0];
      if (!user.storeId) {
        storeId.disabled = true;
        storeId.hidden = true;
      } else {
        storeId.disabled = true;
        storeId.defaultValue = user.storeId;
        storeId.hidden = true;
      }
    },
    setRelateType(params) {
      let user = this.$utils.getSysUser();
      let relateType = params.filter((item) => item.prop === "relateType")[0];
      let deliverStoreId = params.filter((item) => item.prop === "deliverStoreId")[0];
      if (!user.storeId) {
        relateType.disabled = false;
        relateType.defaultValue = user.type;
        relateType.hidden = false;
        deliverStoreId.hidden = true;
      } else {
        relateType.disabled = true;
        relateType.defaultValue = user.type;
        relateType.hidden = false;
        deliverStoreId.disabled = true;
        deliverStoreId.defaultValue = user.storeId;
        deliverStoreId.hidden = false;

      }
    },
    setRelateStoreId(params) {
      let user = this.$utils.getSysUser();
      let relateType = params.filter((item) => item.prop === "relateType")[0];
      let deliverStoreId = params.filter((item) => item.prop === "storeId")[0];
      if (!user.storeId) {
        relateType.disabled = false;
        relateType.defaultValue = 10;
        relateType.hidden = false;
        deliverStoreId.hidden = true;
      } else {
        relateType.disabled = true;
        relateType.defaultValue = 20;
        relateType.hidden = false;
        deliverStoreId.disabled = true;
        deliverStoreId.defaultValue = user.storeId;
        deliverStoreId.hidden = false;

      }
    },
    setDadjapStoreId(params) {
      let user = this.$utils.getSysUser();
      let deliverStoreId = params.filter((item) => item.prop === "storeId")[0];
      if (user.storeId) {
        deliverStoreId.disabled = true;
        deliverStoreId.defaultValue = user.storeId;
        // deliverStoreId.hidden = false;
      }
    },
    // 默认门店禁用 商户总部-1
    setStoreId(params) {
      let user = this.$utils.getSysUser();
      let deliverStoreId = params.filter((item) => item.prop === "storeId")[0];
      if (user.storeId) {
        deliverStoreId.disabled = true;
        deliverStoreId.defaultValue = user.storeId;
      } else {
        deliverStoreId.disabled = false;
        deliverStoreId.defaultValue = -1;
      }
    },
    // 默认门店隐藏 商户总部‘’
    setStoreIdNull(params){
      let user = this.$utils.getSysUser();
      let deliverStoreId = params.filter((item) => item.prop === "storeId")[0];
      if (user.storeId) {
        deliverStoreId.disabled = true;
        deliverStoreId.defaultValue = user.storeId;
        deliverStoreId.hidden = true;
      } else {
        deliverStoreId.disabled = false;
        deliverStoreId.defaultValue = '';
      }
    },
    //调拨模块默认值
    setDnStoreId(params) {
      let user = this.$utils.getSysUser();
      let deliverStoreId = params.filter((item) => item.prop === "requireStoreId")[0];
      if (user.storeId) {
        deliverStoreId.disabled = true;
        deliverStoreId.defaultValue = user.storeId;
      }
      // else {
      //   deliverStoreId.disabled = false;
      //   deliverStoreId.defaultValue = -1;
      // }
    },

    setWholeasleRelateType(params) {
      let user = this.$utils.getSysUser();
      let relateType = params.filter((item) => item.prop === "relateType")[0];
      let wholesaleStoreId = params.filter((item) => item.prop === "wholesaleStoreId")[0];
      if (!user.storeId) {
        relateType.disabled = false;
        relateType.defaultValue = user.type;
        relateType.hidden = false;
        wholesaleStoreId.hidden = true;
      } else{
        relateType.disabled = true;
        relateType.defaultValue = user.type;
        relateType.hidden = false;
        wholesaleStoreId.disabled = true;
        wholesaleStoreId.defaultValue = user.storeId;
        wholesaleStoreId.hidden = false;

      }
    },

    setSupplier(params) {
      let user = this.$utils.getSysUser();
      let supplierId = params.filter((item) => item.prop === "supplierId")[0];
      supplierId.param = {
        relateType: user.type
      }
    },
    setWarehouse(params) {
      let user = this.$utils.getSysUser();
      let warehouseId = params.filter((item) => item.prop === "warehouseId")[0];
      warehouseId.param = {
        relateType: user.type
      };
      warehouseId.defaultValue = user.warehouseId;
    },
    setBrand(params) {
      let user = this.$utils.getSysUser();
      let brandId = params.filter((item) => item.prop === "brandId")[0];
      brandId.param = {
        relateType: user.type
      };
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixin/userPower.js